import React, { useEffect, useState } from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { messageError, messageToast } from '../../utils/define';
import { nguoiPhoiHopGetItemAction, editNguoiPhoiHopAction } from '../../store/reducers/nguoiphoihop';
import ReactSpinner from '../../components/reactSpinner/ReactSpinner';

const schema = yup.object().shape({
    name: yup.string().required(messageError.emptyMessage),
    phone: yup.string()
});

const NguoiPhoiHopEdit = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const item = useSelector((state) => state.nguoiPhoiHop.nguoiPhoiHopItem);

    const [isLoading, setIsLoading] = useState(false);
    const [id, setId] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(location.search.substring(1));
        if (params.get('id')) {
            const idParam = params.get('id');
            setId(idParam);
            dispatch(nguoiPhoiHopGetItemAction(idParam));
        }
    }, [dispatch, location.search]);

    const handleEdit = async (values) => {
        const modelUpdate = { id, data: values };
        try {
            const result = await dispatch(editNguoiPhoiHopAction(modelUpdate));
            if (result.payload !== 200) {
                toast.error(messageToast.messageToastUpdateError);
            } else {
                setIsLoading(true);
                toast.success(messageToast.messageToastUpdateSuccess);
                history.goBack();
            }
        } catch (error) {
            toast.error('Đã có lỗi xảy ra, vui lòng thử lại !');
        }
    };

    return (
        <Card>
            <Card.Header as="h5">Sửa Người phối hợp</Card.Header>
            <Card.Body>
                {item == null ? (
                    <div>Người phối hợp không tồn tại</div>
                ) : (
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(values) => handleEdit(values)}
                        initialValues={{ name: item?.name || '', phone: item?.phone || '' }}
                    >
                        {({ handleSubmit, handleChange, values, errors }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">Tên</Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            placeholder="Tên"
                                            type="text"
                                            name="name"
                                            value={values.name}
                                            onChange={handleChange}
                                            isInvalid={!!errors.name}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="mb-3">
                                    <Col md={{ span: 10, offset: 2 }}>
                                        <ButtonGroup>
                                            <Button type="submit" theme="primary">Sửa</Button>
                                            &nbsp;&nbsp;&nbsp;
                                            <Button onClick={() => history.goBack()} theme="secondary">Hủy</Button>
                                        </ButtonGroup>
                                    </Col>
                                </Form.Group>
                            </Form>
                        )}
                    </Formik>
                )}

                <ReactSpinner loadings={isLoading} />
            </Card.Body>
        </Card>
    );
};

export default NguoiPhoiHopEdit;
